"use strict";

exports.__esModule = true;
exports.MetricQueryGenerator = MetricQueryGenerator;
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _fetchSection = require("../../VIMANAMetrics/Sections/fetchSection");
var _TimeContext = require("../../Time/TimeContext");
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var isEmpty = require("ramda").isEmpty;
var assocPath = require("ramda").assocPath;
var dissoc = require("ramda").dissoc;
var pipe = require("ramda").pipe;
function omitUnwanted(item) {
  return pipe(dissoc("name"), dissoc("label"), dissoc("props"), dissoc("type"), dissoc("filterGroup"))(item);
}

// TODO: cleaner abstractions to accommodate workday and hour in same aggregate by section.
function createQuery(item, value, timezoneOffset) {
  if (value === _timeAggregationBinMapping.HOUR_OF_DAY) {
    return {
      binName: "by_hour",
      fieldName: "timestamp",
      aggType: "script",
      options: {
        scriptName: "hour_of_day",
        scriptParams: {
          fieldName: "timestamp",
          timezoneOffset: timezoneOffset
        }
      }
    };
  } else if (value === _timeAggregationBinMapping.HOUR_PER_DAY) {
    return {
      binName: "by_hour",
      fieldName: "timestamp",
      aggType: "date_histogram",
      options: {
        calendar_interval: "hour"
      }
    };
  }
  var valuePath = item.props.valuePath.split(".");
  return pipe(assocPath(valuePath, value), dissoc("name"), dissoc("label"), dissoc("props"), dissoc("type"), dissoc("filterGroup"))(item);
}
function getFilters(filtersList, filtersDict, filters) {
  return filtersList.filter(function (filter) {
    return !filter.props.presentation.showInEditor;
  }).map(function (filter) {
    var getValue = function getValue(filter) {
      return filtersDict[filter.props.values.source];
    };
    return createQuery(filter, getValue(filter));
  }).concat(filters.map(function (filter) {
    var otherFilters = filtersList.find(function (f) {
      return f.name === filter.name;
    });
    if (!otherFilters) {
      return null;
    }
    if (isEmpty(filter.values)) {
      return null;
    }
    if (otherFilters.props.valuePath === null) {
      return omitUnwanted(otherFilters);
    }
    return omitUnwanted(assocPath(otherFilters.props.valuePath.split("."), filter.values, otherFilters));
  })).filter(function (val) {
    return val !== null;
  });
}
function createBin(aggregates, timezoneOffset) {
  return function (bin) {
    if (!isEmpty(bin.props.values)) {
      var value = aggregates.find(function (agg) {
        return bin.name === agg.groupId;
      }).name;
      bin = createQuery(bin, value, timezoneOffset);
    }
    return omitUnwanted(bin);
  };
}
function MetricQueryGenerator(props) {
  var query = props.query,
    filters = props.filters,
    filtersDict = props.filtersDict,
    updateQuery = props.updateQuery,
    children = props.children;
  var time = _react["default"].useContext(_TimeContext.TimeContext);
  var formattedTimezoneOffset = _momentTimezone["default"].utc().tz(time.timezone.name).format("Z");
  var aggregates = children.map(function (child) {
    return child.props;
  }).filter(function (child) {
    return child.section === "aggregates";
  });
  var metrics = children.map(function (child) {
    return child.props;
  }).filter(function (child) {
    return child.section === "metrics";
  });
  var filtersList = (0, _fetchSection.fetchSection)("filters");
  var mustFilterList = filtersList.filter(function (filter) {
    return filter.filterGroup === "must" || filter.filterGroup === "any";
  });
  var mustNotFilterList = filtersList.filter(function (filter) {
    return filter.filterGroup === "mustNot" || filter.filterGroup === "any";
  });
  var aggregateList = (0, _fetchSection.fetchSection)("aggregates");
  (0, _react.useEffect)(function () {
    var bins = aggregates.map(function (aggregate) {
      return aggregateList.find(function (agg) {
        return agg.name === aggregate.groupId;
      });
    });
    bins = bins.map(createBin(aggregates, formattedTimezoneOffset));
    var updatedQuery = {
      filters: {
        must: getFilters(mustFilterList, filtersDict, filters.filter(function (filter) {
          return filter.filterGroup === "must";
        })),
        mustNot: getFilters(mustNotFilterList, filtersDict, filters.filter(function (filter) {
          return filter.filterGroup === "mustNot";
        }))
      },
      bins: bins,
      metrics: metrics.map(function (metric) {
        return metric.name;
      })
    };
    if (!(0, _reactFastCompare["default"])(updatedQuery, query)) {
      updateQuery(updatedQuery);
    }
  }, [aggregates, metrics, filters, filtersDict]);
  return null;
}